var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4383_18954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50247 1V6.5M11.0025 4.9V2.6C11.0025 2.03995 11.0025 1.75992 10.8935 1.54601C10.7976 1.35785 10.6446 1.20487 10.4565 1.10899C10.2425 1 9.96252 1 9.40247 1H4.06147C3.33073 1 2.96536 1 2.67026 1.13372C2.41017 1.25157 2.18912 1.44121 2.03309 1.68036C1.85605 1.9517 1.8005 2.31282 1.68938 3.03506L1.42784 4.73506C1.28129 5.68766 1.20801 6.16395 1.34937 6.53456C1.47344 6.85985 1.70679 7.13185 2.00943 7.30393C2.35423 7.5 2.83613 7.5 3.79994 7.5H4.20247C4.48249 7.5 4.62251 7.5 4.72946 7.5545C4.82354 7.60243 4.90003 7.67892 4.94797 7.773C5.00247 7.87996 5.00247 8.01997 5.00247 8.3V9.76708C5.00247 10.448 5.55446 11 6.23539 11C6.3978 11 6.54498 10.9044 6.61094 10.7559L8.29132 6.97509C8.36775 6.80312 8.40596 6.71714 8.46637 6.65409C8.51976 6.59836 8.58533 6.55575 8.65794 6.52959C8.74009 6.5 8.83418 6.5 9.02237 6.5H9.40247C9.96252 6.5 10.2425 6.5 10.4565 6.39101C10.6446 6.29513 10.7976 6.14215 10.8935 5.95399C11.0025 5.74008 11.0025 5.46005 11.0025 4.9Z",
    stroke: "#7BA4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4383_18954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownIcon);
export default __webpack_public_path__ + "static/media/thumbsDownIcon.e028e9089f6ef4369f63a00eb9347676.svg";
export { ForwardRef as ReactComponent };